export default __webpack_public_path__ + "static/media/baseline-info-24px.8d9fd9d3.svg";